
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../../../../../Helper/Context";
import { Loading } from "../../../../../../../../../Helper/Loading";
import { PathakPopUpTableDataAPI } from "../../../../../../../../../Redux/EnchrochmentDashboardSlice/ComplaintStatusOfficialsSlice/AcknowledgedComplaintSlice";

const PathakNamePopUp = (props) => {

    const { handlePathakDetails, heading, gridData, DashSelect, YearValue, MonthValue, ZoneValue, Flag, Language } = props

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const [IsClear, setIsClear] = useState(false)
    const [IsSearch, setIsSearch] = useState(false)

    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [ClosedComplaintData, setClosedComplaintData] = useState([])
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [showImagePopup, setshowImagePopup] = useState(false)
    const [Data, setData] = useState([])

    const { t } = useTranslation()

    // handleItemList
    const [ItemList, setItemList] = useState(false)

    const handleItemList = (data) => {
        setItemList(!ItemList)
        setData(data)
    }

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    useEffect(() => {
        const data = {
            M_FinacialYearID: YearValue,
            M_MonthID: MonthValue,
            T_Encroach_ComplaintDetailsID: gridData.t_ComplaintDetailsID,
            T_Encroach_CreateSchedulingID:gridData.t_Encroach_CreateSchedulingID,
            M_PathakID: gridData.m_PathakID,
            M_WorkTypeID: DashSelect,
            Language: Language.Label ,
            Flag: Flag,
            M_UserID: UserID,
            FromTop: From,
            ToTop: To,
            token: token,
            setClosedComplaintData: setClosedComplaintData
        }
        dispatch(PathakPopUpTableDataAPI({ data }))
    }, [YearValue, MonthValue, DashSelect, From, IsClear, IsSearch, Language.Label, ZoneValue])

    const { isLoading, tableData } = useSelector(state => state.PathakPopUpTableData)


    return (
        <>
            <div className="modal fade show" style={{ display: "flex", alignItems: 'center', backgroundColor: "#00000090" }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content p-3">
                        <div className="modal-header pt-0">

                            <h5 className="card-title fw-bold" id="exampleModalLongTitle">
                                {heading}
                            </h5>
                            <button onClick={() => handlePathakDetails()} type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        {isLoading && <Loading/>}
                        <div className="modal-body">

                            <div className="row" >
                                <div className="col-12  " >
                                <div className="table-responsive table-responsive-fix">
                                        <table className="table table-striped table-bordered">
                                            <thead className="header_position">
                                                <tr>
                                                    <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.DesignationName')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.EmployeeName')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.EmployeeCount')}</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    ClosedComplaintData && ClosedComplaintData?.length > 0 ? ClosedComplaintData?.map((i, j) => {
                                                        return (
                                                            <tr>
                                                                <td className="py-1" align="center">{i.rowNum}</td>
                                                                <td className="nowrap" >{i.designationName ? i.designationName : '-'}</td>
                                                                <td className="nowrap" >{i.employeeName ? i.employeeName : '-'}</td>
                                                                <td className="nowrap" >{i.employeeCount ? i.employeeCount : '-'}</td>
                                                            
                                                            </tr>
                                                        )
                                                    })
                                                        :
                                                        <tr>
                                                            <td colSpan={10}>No data found ...</td>
                                                        </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* {ClosedComplaintData && ClosedComplaintData.length > 0 &&
                                        <Pegination
                                            PerPageCount={PerPageCount}
                                            TotalCount={ClosedComplaintData && ClosedComplaintData[0].totalCount}
                                            setFrom={setFrom}
                                            setTo={setTo}
                                            CurrentPage={CurrentPage}
                                            setCurrentPage={setCurrentPage}
                                            IsClear={IsClear}
                                        />
                                    } */}

                                </div>




                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="row">
                                {/* <div className="col-12 pt-3">
                                    <button
                                        type='button'
                                        // onClick={() => confirmBtnCallBack(deleteRecord)}
                                        className="w-80 btn addbtn btn-success btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                       
                                        {t('EncroachmentDashboard.Forward')}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleSiteVerificationDetails}
                                        className="w-80  btn addbtn btn-danger btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                        <i class="fa-solid fa-xmark pe-1"></i> Cancel

                                    </button>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>);
}

export default PathakNamePopUp;